'use client'

import React from "react";
import {cn} from "@/lib/utils";

export default function CursorBubble({
  className,
  name,
  color,
}: {
  className?: string;
  name: string;
  color: string;
}){
  return (
    <div className={cn(
      "absolute",
      className
    )}>
      <div
        className="relative rounded-tr-[30px] rounded-br-[30px] rounded-bl-[30px] rounded-tl-[5px] h-[5rem] px-[2.25rem] text-[#0A1A1D] font-medium leading-none flex items-center justify-center"
        style={{
          backgroundColor: color ?? "#D9F9B9",
        }}
      >
        {name}
        <div className="absolute left-0 top-0 -translate-x-[2.125rem] -translate-y-[2.125rem] !w-[2.5rem]">
          <svg className="!w-full" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.13113 16.9592L1.99986 1.00011L16.377 8.87741L9.29501 10.9319L5.13113 16.9592Z" fill={color ?? "#D9F9B9"}/>
          </svg>
        </div>
      </div>
    </div>
  );
}